import {
  useGetCreditLimitQuery,
  useGetCustomerBlockQuery
} from "@saleor/graphql";
import useNotifier from "@saleor/hooks/useNotifier";
import { useState } from "react";

const useCustomerCreditStatus = formik => {
  const notify = useNotifier();
  const [openModalCreditBlock, setOpenModalCreditBlock] = useState<boolean>(
    false
  );
  const [openModalCustomerBlock, setOpenModalCustomerBlock] = useState<boolean>(
    false
  );
  const toggleModalCreditBlock = () => {
    setOpenModalCreditBlock(val => !val);
  };
  const toggleModalCustomerBlock = () => {
    setOpenModalCustomerBlock(val => !val);
  };

  const { refetch: refetchCreditCheck } = useGetCreditLimitQuery({
    fetchPolicy: "no-cache",
    variables: {
      input: {
        salesOrgCode: formik?.values?.salesOrganizationCode,
        soldToCode: formik?.values?.soldToCode
      }
    },
    skip: true
  });
  const { refetch: refetchCustomerCheck } = useGetCustomerBlockQuery({
    fetchPolicy: "no-cache",
    variables: {
      input: {
        soldToCode: formik?.values?.soldToCode
      }
    },
    skip: true
  });

  const callCustomerCreditBlock = () =>
    Promise.all([
      refetchCustomerCheck({
        input: {
          saleOrganizationCode: formik?.values?.salesOrganizationCode,
          soldToCode: formik?.values?.soldToCode
        }
      }),
      refetchCreditCheck({
        input: {
          salesOrgCode: formik?.values?.salesOrganizationCode,
          soldToCode: formik?.values?.soldToCode
        }
      })
    ])
      .then(([customerCheckRes, creditCheckRes]) => {
        if (customerCheckRes.data?.getCustomerBlock?.customerBlock) {
          toggleModalCustomerBlock();
          return true;
        }

        if (creditCheckRes.data?.getCreditLimit?.creditBlockStatus) {
          toggleModalCreditBlock();
          return true;
        }
        const customerError = customerCheckRes?.errors;
        const creditError = creditCheckRes?.errors;
        if (customerError?.length > 0 || creditError?.length > 0) {
          notify({
            status: "error",
            apiMessage: customerError?.[0]?.message || creditError?.[0]?.message
          });
          return true;
        }
        return false;
      })
      .catch(error => {
        notify({
          status: "error",
          apiMessage: error.message
        });
        return true;
      });

  return {
    toggleModalCreditBlock,
    toggleModalCustomerBlock,
    openModalCustomerBlock,
    openModalCreditBlock,
    callCustomerCreditBlock
  };
};

export default useCustomerCreditStatus;
